<template>
    <div class="title-message-card">
        <div v-for="(item, i) in items" :key="i">
            <p :class="item.titleClass">
                {{ item.title }}
            </p>
            <p :class="item.messageClass">
                {{ item.message }}
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'title-message-card',
    props: {
        items: {
            type: Array,
            required: true
        }
    }
}
</script>
<style lang="scss" scoped>
 @import '../../assets/scss/breakpoint';
 
.title-message-card {
    color: var(--light-dark-color);
    background-color: #f1f0f0;
    width: 100%;
    padding: 20px;
    margin: 10px 5px;
    text-align: center;

    p {
        margin: 0;
    }

    div {
        margin: 0 auto 15px;
        width: 50%;

        @include breakpoint(mobile) {
          width: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/TitleMessageCard.vue